import { ITimeOfDay } from 'Components/flowChart/components/NodePreview/components/NodeDelay/types';
import { FORMAT_FULL_DATE, FORMAT_HOUR } from 'Components/flowChart/components/NodePreview/constants';
import moment from 'moment-timezone';

export const getTriggerTime = (timeOfDay: ITimeOfDay, _timezone: string, date?: string) => {
	try {
		const { hour, minute } = timeOfDay;

		if (date && hour && minute) {
			return moment(`${date} ${hour}:${minute}`, 'DD-MM-YYYY HH:mm').format(FORMAT_FULL_DATE);
		} else if (hour && minute) {
			return moment(`${hour}:${minute}`, 'HH:mm').format(FORMAT_HOUR);
		}

		return null;
	} catch (error) {
		return null;
	}
};
